import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ProjectService} from '../../../shared/services/project/project.service';
import {NotationService} from '../../../shared/services/notation/notation.service';
import {environment} from '../../../../environments/environment';
import {ToastrService} from 'ngx-toastr';
import {MatDialog} from '@angular/material/dialog';
import {LocationPlan} from '../../../shared/classes/plan/location-plan';
import {faEdit} from '@fortawesome/free-solid-svg-icons/faEdit';
import {UploadPlanComponent} from './upload-plan/upload-plan.component';
import {IconService} from '../../../shared/services/icon/icon.service';


@Component({
  selector: 'app-project-location-plan',
  templateUrl: './project-location-plan.component.html',
  styleUrls: ['./project-location-plan.component.scss']
})
export class ProjectLocationPlanComponent implements OnInit {

  listLocations: any[] = [];
  plans: any[] = [];
  showSpinner: boolean = false;
  mapOpacity: number;
  projectName: string;
  faEdit = faEdit;
  selectedPlanIndex = 0;
  idProject: any;

  @ViewChild('plan') private planRef: ElementRef;


  constructor(
    public iconService: IconService,
    private projectService: ProjectService,
    private notationService: NotationService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private modal: MatDialog
  ) {
  }

  ngOnInit() {
    this.idProject = this.route.snapshot.paramMap.get('idProject');
    this.initComponent();
  }

  initComponent(indexPlanToDisplay: number = undefined) {
    this.showSpinner = true;
    this.mapOpacity = 0.3;
    this.projectService.getProject(this.idProject, 'locations,notations,plans')
      .subscribe(
        (project: any) => {
          let newProjectDeviceLocations = [];
          project.project_device_locations.forEach(pdl => {
            if (pdl.active === true) {
              if (pdl.children) {
                let newProjectDeviceLocationsChild = [];
                pdl.children.forEach(child => {
                  if (child.active === true) {
                    newProjectDeviceLocationsChild.push(child);
                  }
                });
                pdl.children = newProjectDeviceLocationsChild;
              }
              newProjectDeviceLocations.push(pdl);
            }
          });
          project.project_device_locations = newProjectDeviceLocations;
          this.projectName = project.name;
          let formattedDevices = this.notationService.addIconUrlsToDevices(project.project_device_locations, project.note_project_users_current);
          this.listLocations = this.notationService.orderDevices(formattedDevices);
          this.plans = project.project_plans
            .filter(
              (plan) => plan.active && plan.image_name
            )
            .map(
              (plan) => {
                plan.url = environment.apiUrl + 'images/plans/' + plan.image_name;
                // Add list location's objects properties to plan location's objects and opposite
                plan.location_plans = this.mergePlanAndListLocations(plan.location_plans);
                return plan;
              }
            );
          if (indexPlanToDisplay !== undefined) {
            this.selectedPlanIndex = indexPlanToDisplay;
          }
          this.showSpinner = false;
        }
      );
  }

  updatePosition(event: any, locationMarker) {
    let planRef = document.getElementById('planSubCont');
    this.showSpinner = true;
    let transform = event.source._dragRef._activeTransform;
    let locationPlan = {
      pos_x: locationMarker.pos_x + ((transform.x / planRef.clientWidth) * 100),
      pos_y: locationMarker.pos_y + ((transform.y / planRef.clientHeight) * 100)
    };
    this.projectService.patchLocationPlan(locationMarker.id, locationPlan)
      .subscribe(
        () => {
          this.toastr.success('Localisation updated');
          this.showSpinner = false;
        }, () => this.showSpinner = false
      );
  }

  toggleSelectedMarker(markerId: any, action: 'select' | 'unselect') {
    if (action === 'select') {
      this.selectMarkerOnPlan(markerId);
      this.selectMarkerOnList(markerId);
    } else {
      this.unselectMarker(this.plans[this.selectedPlanIndex].location_plans);
      this.unselectMarker(this.listLocations);
    }
  }

  openUploadPlanModal() {
    const modalRef = this.modal.open(UploadPlanComponent, {
      width: '1000px',
      data: {
        idProject: this.idProject
      }
    });
    modalRef.afterClosed().subscribe(
      () => {
        this.initComponent();
      }
    );
  }

  addMarkerToPlan(marker) {
    let planRef = document.getElementById('planSubCont');
    if (!planRef) {
      alert('No plan updated.');
      return;
    }
    this.showSpinner = true;
    let pos_x = 50;
    let pos_y = 50;
    let newLocation: LocationPlan = {
      project_device_location: marker.id,
      project_plan: this.plans[this.selectedPlanIndex].id,
      pos_x,
      pos_y,
      active: true
    };
    this.projectService.postLocationPlan(newLocation)
      .subscribe(
        (newLocation: any) => {
          this.showSpinner = false;
          this.toastr.success('Location added');
          this.initComponent();
        },
        () => this.showSpinner = false
      );

  }

  deleteMarkerFromPlan(markerLocationId) {
    this.showSpinner = true;
    this.projectService.deleteLocationPlan(markerLocationId)
      .subscribe(
        () => {
          this.showSpinner = false;
          this.toastr.success('Location deleted.');
          this.initComponent();
        },
        () => this.showSpinner = false
      );
  }

  displayPlan(planIndex: number) {
    this.showSpinner = true;
    this.initComponent(planIndex);
  }

  changePlanName(planId, name) {
    this.projectService.patchProjectPlan(planId, {name})
      .subscribe(
        () => {
          this.showSpinner = false;
          this.toastr.success('Name updated');
          this.initComponent();
        },
        () => this.showSpinner = false
      );
  }

  deletePlan(planId) {
    this.showSpinner = true;
    this.projectService.deleteProjectPlan(planId)
      .subscribe(
        () => {
          this.showSpinner = false;
          this.toastr.success('Plan deleted.');
          this.initComponent(this.selectedPlanIndex > 0 ? this.selectedPlanIndex - 1 : undefined);
        },
        () => this.showSpinner = false
      );
  }

  private mergePlanAndListLocations(planLocations) {
    return planLocations.reduce(
      (updatedPlanLocations, planLocation) => {
        if (!planLocation.active) {
          return updatedPlanLocations;
        }
        let i = this.listLocations.findIndex(
          (listLocation) => listLocation.id === planLocation.location_id);
        if (i === -1) {
          return updatedPlanLocations;
        }
        this.listLocations[i].location_plan_id = planLocation.id;   // Add the plan location ID to the marker object
        let updatedPlanLocation = Object.assign({}, this.listLocations[i], planLocation);
        return updatedPlanLocations.concat(updatedPlanLocation);
      }, []
    );
  }

  private selectMarkerOnPlan(selectedMarkerId) {
    this.plans[this.selectedPlanIndex].location_plans.forEach(
      (marker) => {
        if (marker.id === selectedMarkerId) {
          marker.selected = true;
          marker.disabled = undefined;
        } else {
          marker.selected = undefined;
          marker.disabled = true;
        }
      }
    );
  }

  private selectMarkerOnList(selectedMarkerId) {
    this.listLocations.forEach(
      (marker) => {
        if (marker.id === selectedMarkerId) {
          marker.selected = true;
          marker.disabled = undefined;
        } else {
          marker.selected = undefined;
          marker.disabled = true;
        }
      }
    );
  }

  private unselectMarker(markerArray: any[]) {
    markerArray.forEach(
      (marker) => {
        marker.selected = undefined;
        marker.disabled = undefined;
      }
    );
  }

}
